import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@/providers/AuthProvider';

export const Route = createFileRoute('/access-denied')({
  component: AccessDeniedPage,
});

function AccessDeniedPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate({ to: '/login', replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand p-8">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-10 text-center">
        <div className="mb-6">
          <div className="mx-auto w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <svg
              className="w-10 h-10 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Access Denied
          </h1>
          <p className="text-gray-600">
            You do not have permission to access this admin panel.
          </p>
          <p className="text-gray-600 mt-2">
            This area is restricted to administrators only.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleLogout}
            className="w-full bg-brand text-white rounded-full py-3 px-6 font-medium hover:opacity-90 transition-all"
          >
            Sign Out
          </button>

          <p className="text-sm text-gray-500">
            If you believe this is an error, please contact your administrator.
          </p>
        </div>
      </div>
    </div>
  );
}
